import { render, staticRenderFns } from "./DocumentCreateContainer.vue?vue&type=template&id=b2024e9e"
import script from "./DocumentCreateContainer.vue?vue&type=script&lang=js"
export * from "./DocumentCreateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports